import { GeneralError } from '@shared/components';
import React from 'react';

export const LayoutChildrenFallback = (): JSX.Element => {
  return <GeneralError />;
};
